import React from 'react';
import '../styles/Footer.css';
import { FaFacebook, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                {/* NOTA: Coloca aquí tu logo del Quetzal */}
                <img 
                  src="/logo.png" 
                  alt="M502 Construction LLC" 
                  className="footer-logo-img"
                />
                <h3>M502CONSTRUCTIONLLC</h3>
              </div>
              <p className="footer-tagline">Strong foundations, stronger trust.</p>
              <p className="footer-description">
                Your trusted construction partner in San Marcos, Texas. 
                Quality work, honest pricing, and exceptional service.
              </p>
            </div>

            <div className="footer-section">
              <h4>Our Services</h4>
              <ul className="footer-services">
                <li>Masonry & Concrete</li>
                <li>Stone Work & Brick</li>
                <li>Landscaping Services</li>
                <li>Tree Services</li>
                <li>Fence Installation</li>
                <li>Junk Removal</li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="tel:512-648-9102">Free Estimate</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Contact Info</h4>
              <div className="footer-contact">
                <a href="tel:512-648-9102" className="footer-contact-item">
                  <FaPhone /> 512-648-9102
                </a>
                <a href="mailto:M502ConstructionLLC@gmail.com" className="footer-contact-item">
                  <FaEnvelope /> M502ConstructionLLC@gmail.com
                </a>
                <a href="https://maps.google.com" className="footer-contact-item">
                  <FaMapMarkerAlt /> 1812 Dara Lane, San Marcos, TX 78666
                </a>
              </div>
              
              <div className="footer-social">
                <a href="#" aria-label="Facebook" className="social-link">
                  <FaFacebook />
                </a>
                <a href="#" aria-label="Instagram" className="social-link">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} M502 Construction LLC. All rights reserved.</p>
            <p>Licensed & Insured | Free Estimates</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;